import React from "react";
import { View, Image, Text } from "react-native";

import styles from "./styles";
import { FormattedMessage } from "react-intl";

const HeaderInfoCoin = ({ dataCoin }) => {
  return (
    <>
      {dataCoin && (
        <View style={styles.container}>
          <View style={styles.imageContainer}>
         {/*    <Image
              style={styles.imgCoin}
              source={{
                uri:
                  dataCoin.actives !== undefined
                    ? `https://filesgpx.s3.us-east-2.amazonaws.com/${dataCoin.actives[0].path}`
                    : null,
              }}
            /> */}
            <View style={{ flexDirection: "column" }}>
              <Text style={styles.nameCoin}>
                {dataCoin.actives !== undefined
                  ? dataCoin.actives[0].name_token
                  : ""}
              </Text>
              <Text style={styles.priceCoin}>
                {dataCoin.actives !== undefined
                  ? dataCoin.actives[0].type_value == "Valor Fixo"
                    ? parseFloat(dataCoin.actives[0].single_value).toFixed(2)
                    : parseFloat(dataCoin.actives[0].total_value_token).toFixed(
                        2
                      )
                  : "000.00"}{" "}
                <FormattedMessage id="headerinfocoin.gpxBrl" />
              </Text>
            </View>
          </View>
        </View>
      )}
    </>
  );
};

export default HeaderInfoCoin;
